"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _renderer = _interopRequireDefault(require("@widget-editor/renderer"));

var _editorOptions = _interopRequireDefault(require("../editor-options"));

var _footer = _interopRequireDefault(require("../footer"));

var _core = require("@widget-editor/core");

var _style = require("./style");

var _exposedHooks = require("../../exposed-hooks");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Editor =
/*#__PURE__*/
function (_react$default$Compon) {
  _inherits(Editor, _react$default$Compon);

  function Editor(props) {
    var _this;

    _classCallCheck(this, Editor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Editor).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "initializeRestoration", (0, _debounce["default"])(function (datasetId, widgetId) {
      var _this$props = _this.props,
          resetFilters = _this$props.resetFilters,
          dispatch = _this$props.dispatch;
      resetFilters();

      _this.dataService.restoreEditor(datasetId, widgetId, function () {
        dispatch({
          type: _core.constants.sagaEvents.DATA_FLOW_UPDATE_HOOK_STATE
        });
      });
    }, 1000));

    _defineProperty(_assertThisInitialized(_this), "resolveTheme", (0, _debounce["default"])(function (userPassedTheme) {
      var _this$props2 = _this.props,
          setTheme = _this$props2.setTheme,
          userPassedCompact = _this$props2.userPassedCompact;
      setTheme(_objectSpread({}, userPassedTheme, {
        compact: _objectSpread({}, _this.props.theme.compact, {
          forceCompact: userPassedCompact || false
        })
      }));
    }, 1000));

    _defineProperty(_assertThisInitialized(_this), "resolveSchemes", (0, _debounce["default"])(function (schemes) {
      var setSchemes = _this.props.setSchemes;

      if (Array.isArray(schemes) && schemes.length > 0) {
        setSchemes(schemes);
      }
    }, 1000));

    var _this$props3 = _this.props,
        _datasetId = _this$props3.datasetId,
        _widgetId = _this$props3.widgetId,
        adapter = _this$props3.adapter,
        setEditor = _this$props3.setEditor,
        _dispatch = _this$props3.dispatch,
        _userPassedTheme = _this$props3.userPassedTheme,
        _schemes = _this$props3.schemes;
    _this.onSave = _this.onSave.bind(_assertThisInitialized(_this));
    _this.dataService = new _core.DataService(_datasetId, _widgetId, adapter, setEditor, _dispatch);

    _this.dataService.resolveInitialState();

    _this.resolveTheme(_userPassedTheme);

    _this.resolveSchemes(_schemes);

    props.dispatch({
      type: _core.constants.sagaEvents.DATA_FLOW_STORE_ADAPTER_CONFIG,
      payload: adapter
    });
    (0, _exposedHooks.setReduxCache)(_dispatch);
    (0, _exposedHooks.localGetEditorState)({
      adapter: adapter,
      dataService: _this.dataService
    });
    return _this;
  }

  _createClass(Editor, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var authenticated = this.props.authenticated;

      if (authenticated) {
        this.resolveAuthentication(authenticated);
      }

      this.resolveEditorFunctionality();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var dispatch = this.props.dispatch;
      dispatch({
        type: _core.constants.sagaEvents.DATA_FLOW_UNMOUNT
      });
      this.resetEditor();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevDatasetId = prevProps.datasetId,
          prevWidgetId = prevProps.widgetId,
          prevUserPassedTheme = prevProps.userPassedTheme,
          prevSchemes = prevProps.schemes;
      var _this$props4 = this.props,
          datasetId = _this$props4.datasetId,
          widgetId = _this$props4.widgetId,
          userPassedTheme = _this$props4.userPassedTheme,
          schemes = _this$props4.schemes;

      if (!(0, _isEqual["default"])(datasetId, prevDatasetId) || !(0, _isEqual["default"])(widgetId, prevWidgetId)) {
        this.initializeRestoration(datasetId, widgetId);
      }

      if (!(0, _isEqual["default"])(userPassedTheme, prevUserPassedTheme)) {
        this.resolveTheme(userPassedTheme);
      }

      if (!(0, _isEqual["default"])(schemes, prevSchemes)) {
        this.resolveSchemes(schemes);
      }
    }
  }, {
    key: "resetEditor",
    value: function resetEditor() {
      var _this$props5 = this.props,
          resetEditor = _this$props5.resetEditor,
          resetConfiguration = _this$props5.resetConfiguration,
          resetWidgetConfig = _this$props5.resetWidgetConfig,
          resetFilters = _this$props5.resetFilters,
          resetTheme = _this$props5.resetTheme;
      resetEditor();
      resetConfiguration();
      resetWidgetConfig();
      resetFilters();
      resetTheme();
    }
  }, {
    key: "resolveEditorFunctionality",
    value: function resolveEditorFunctionality() {
      var _this$props6 = this.props,
          setEditor = _this$props6.setEditor,
          disable = _this$props6.disable,
          _this$props6$enableSa = _this$props6.enableSave,
          enableSave = _this$props6$enableSa === void 0 ? true : _this$props6$enableSa;
      setEditor(_objectSpread({
        enableSave: enableSave
      }, disable !== undefined && disable !== null ? {
        disabledFeatures: disable
      } : {}));
    }
  }, {
    key: "onSave",
    value: function onSave() {
      var _this$props7 = this.props,
          onSave = _this$props7.onSave,
          dispatch = _this$props7.dispatch,
          editorState = _this$props7.editorState,
          adapter = _this$props7.adapter;

      if (typeof onSave === "function") {
        var outputPayload = (0, _core.getOutputPayload)(editorState, adapter);
        onSave(outputPayload);
      }

      dispatch({
        type: _core.constants.sagaEvents.EDITOR_SAVE
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          adapter = _this$props8.adapter,
          compact = _this$props8.theme.compact;
      return _react["default"].createElement(_style.StyledContainer, compact, _react["default"].createElement(_style.StyleEditorContainer, null, _react["default"].createElement(_renderer["default"], {
        standalone: false
      }), _react["default"].createElement(_editorOptions["default"], {
        adapter: adapter,
        dataService: this.dataService
      })), _react["default"].createElement(_footer["default"], {
        onSave: this.onSave
      }));
    }
  }]);

  return Editor;
}(_react["default"].Component);

var _default = Editor;
exports["default"] = _default;